import { Holding } from '@daml.js/dtc-registry-holding/lib/Dtc/Registry/Holding/V3/Holding';
import TemplateContract from './TemplateContract';

/**
 * Holdings visibility has two layers:
 *
 * Layer 1 (server) — The ledger query uses `filtersByParty` to return every
 * Holding contract where the submitter is a "stakeholder" (anyone named on the
 * contract). This already limits results to contracts the user has some
 * connection to.
 *
 * Layer 2 (this function) — Not every stakeholder should see the holding in the
 * UI. During a transfer, the receiver is temporarily added as a "lock observer"
 * on the sender's holding (so the ledger can track the in-flight transfer).
 * That makes the receiver a stakeholder, so Layer 1 returns the sender's locked
 * holding to the receiver. But the receiver has no business relationship with
 * that holding — they're not the owner, registrar, operator,
 * compliance officer, or participant.
 *
 * This function enforces that only users who fill one of those five recognized
 * business roles (and belong to the current operator context) see the holding.
 */
export const filterHoldingsByOperatorAndParty = (
  holdings: TemplateContract<Holding>[],
  operator: string,
  submitter: string,
): TemplateContract<Holding>[] =>
  holdings.filter(
    (h) =>
      h.payload.operator === operator &&
      (h.payload.owner === submitter ||
        h.payload.registrar === submitter ||
        h.payload.operator === submitter ||
        h.payload.compliance === submitter ||
        h.payload.participant === submitter),
  );
